<template>
  <div class="empty-block">
    <img class="empty-img" src="https://image.xiaomaiketang.com/xm/internal/dcreJyebCk.png" alt="">
    <div class="empty-tip">暂无数据</div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
.empty-block{
  display: flex;
  flex-direction: column;
  align-items: center;
  .empty-img{
    width: 2rem;
    margin-top: 3rem;
  }
  .empty-tip{
    margin-top: 0.4rem;
    font-size: 0.3rem;
    color: #999;
  }
}
</style>